import React from 'react';

import Grid from "@mui/material/Grid";

import CustomerNumber from "../components/SandboxField";
import SandboxField from "../components/SandboxField";

function Postnl(props) {
    return (
        <Grid container rowSpacing={2}>
            <Grid item xs={12}>
                <CustomerNumber />
            </Grid>
            <Grid item xs={12}>
                <SandboxField />
            </Grid>
        </Grid>
    );
}

export default Postnl;
